// Small shared formatter used by the Time Travel timeline UI.
// Kept in /map/ next to the components that consume it so the dependency
// graph stays tight; everything outside the map folder uses date-fns.
export function fmtDate(iso) {
  if (!iso || typeof iso !== 'string' || iso.length < 10) return iso || '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
}
